import React, { Component } from 'react';
import { connect } from 'react-redux'

class LoadCursore extends Component {
  render() {
    const { load } = this.props;

    if(!load){
      return null;
    }
    return (
      <div onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }} style={{
        position: 'fixed',
        // background: 'red',
        cursor: 'wait',
        width: '100%',
        minHeight: '100vh',
        zIndex: 999999,
      }} />
    );
  }
}


const mapStateToProps = (state, ownProps) => ({
  load: state.loadCursore.load
})

const mapDispatchToProps = {
  
}

export default connect(mapStateToProps, mapDispatchToProps)(LoadCursore)



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/common/LoadCursore.js